'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar as AvatarPrimitive } from '@base-ui/react/avatar';
import { cn } from '@/utils/cn';
type AvatarProps = AvatarPrimitive.Root.Props & {
  size?: 'default' | 'sm' | 'lg';
};
export function Avatar(props) {
  const $ = _c(10);
  let className;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      className,
      size: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const size = t0 === undefined ? "default" : t0;
  let t1;
  if ($[4] !== className) {
    t1 = cn("group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:border-border after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6 dark:after:mix-blend-lighten", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== rest || $[7] !== size || $[8] !== t1) {
    t2 = <AvatarPrimitive.Root data-slot="avatar" data-size={size} className={t1} {...rest} />;
    $[6] = rest;
    $[7] = size;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
type AvatarImageProps = AvatarPrimitive.Image.Props;
export function AvatarImage(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("aspect-square size-full rounded-full object-cover", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <AvatarPrimitive.Image data-slot="avatar-image" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AvatarFallbackProps = AvatarPrimitive.Fallback.Props;
export function AvatarFallback(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <AvatarPrimitive.Fallback data-slot="avatar-fallback" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AvatarBadgeProps = React.ComponentProps<'span'>;
export function AvatarBadge(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground bg-blend-color ring-2 ring-background select-none group-data-[size=default]/avatar:size-2.5 group-data-[size=lg]/avatar:size-3 group-data-[size=sm]/avatar:size-2 group-data-[size=default]/avatar:[&>svg]:size-2 group-data-[size=lg]/avatar:[&>svg]:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <span data-slot="avatar-badge" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AvatarGroupProps = React.ComponentProps<'div'>;
export function AvatarGroup(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <div data-slot="avatar-group" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type AvatarGroupCountProps = React.ComponentProps<'div'>;
export function AvatarGroupCount(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("relative flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm text-muted-foreground ring-2 ring-background group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <div data-slot="avatar-group-count" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}